import { Component, OnInit } from '@angular/core';
import { RolePipe } from '@monsido/core/pipes/role/role.pipe';
import { Report } from '@monsido/modules/models/api/report';
import { ReportCenterDashboardService } from '../../services/dashboard/report-center-dashboard.service';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ReportRepoService } from '@client/app/services/api/report-repo/report-repo.service';

@Component({
    selector: 'mon-report-center-dashboard',
    templateUrl: './report-center-dashboard.component.html',
    styleUrls: ['./report-center-dashboard.component.scss'],
    standalone: false,
})
export class ReportCenterDashboardComponent implements OnInit {
    subHeader: string;
    monHref: string = 'https://help.monsido.com/en/articles/4885326-report-center';
    reports: Report[] = [];
    loading: boolean = false;
    scheduledReports: Report[] = [];

    constructor (
        private translateService: TranslateService,
        private monRole: RolePipe,
        private dashboardService: ReportCenterDashboardService,
        private activeFeatureService: ActiveFeatureService,
        private reportRepoService: ReportRepoService,
    ) {
        const adminText = this.monRole.transform(['customer_admin']) ? 'or other users' : '';
        this.subHeader = this.translateService.getString('Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan', {
            adminText: adminText,
        });
    }

    ngOnInit (): void {
        this.getPage();
    }

    getPage (): void {
        this.loading = true;
        this.reportRepoService.get().then((reports) => {
            this.reports = reports.filter(report => {
                if (report.template.name.startsWith('uptimes')) {
                    return this.activeFeatureService.isFeatureActive('admin_heartbeat');
                }

                if (report.template.name.startsWith('stats')) {
                    return this.activeFeatureService.isFeatureActive('admin_statistics');
                }

                if (report.template.name.startsWith('heatmaps')) {
                    return this.activeFeatureService.isFeatureActive('heatmaps');
                }

                return true;
            });

            this.scheduledReports = this.reports.filter(report => {
                const users = this.dashboardService.getUniqueUsersByIdFromReport(report);
                return this.dashboardService.isReceivingReport(users);
            });
        })
            .finally(() => {
                this.loading = false;
            });
    }

}
